import { Component, ReactNode } from "react";
import { KnownThomasError } from "../../ErrorState/ErrorState";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

const DEFAULT_MESSAGE = "Unexpected error claiming project";

class ClaimErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, message: DEFAULT_MESSAGE };
  }

  public static getDerivedStateFromError(err: Error): State {
    let message = err.message || DEFAULT_MESSAGE;
    if (err.name) {
      message = `${err.name} - ${message}`;
    }

    return { hasError: true, message };
  }

  public render() {
    const { hasError, message } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <KnownThomasError
          title="Error Claiming Project"
          errorMessage={
            message ??
            "An unexpected error occurred while trying to claim this project."
          }
        />
      );
    }

    return children;
  }
}

export default ClaimErrorBoundary;
